document.documentElement.classList.remove('no-js');

document.addEventListener('click', function(e){
  var btn = e.target.closest('.product-thumbnail-btn');
  if(!btn) return;
  var newSrc = btn.getAttribute('data-full-src');
  var mainImg = document.querySelector('.product-main-img');
  if(mainImg && newSrc){
    mainImg.src = newSrc;
  }
  document.querySelectorAll('.product-thumbnail-btn').forEach(function(b){ b.classList.remove('is-active'); });
  btn.classList.add('is-active');
});
